import axios from "axios";
import Masonry from "masonry-layout";
export default function(opts = {}, masonryOpts = {}) {

  const defaultOptions = {
      page: 1,
      category: null,
  }

  const defaultMasonryOptions = {
    gutter: window.screen.width < 640 ? 10 : 20,
  }

  const options = { ...defaultOptions, ...opts }
  const masonryOptions = { ...defaultMasonryOptions, ...masonryOpts }

  return {
    masonry: null,
    page: null,
    category: null,
    offset: null,
    loading: false,
    entries: [],

    init() {
      this.masonry = new Masonry(this.$refs.articles, masonryOptions);
      this.page = options.page;
      this.offset = options.offset;
      this.category = options.category;
    },

    get more() {
      const articleCount = this.$refs.articles.getElementsByClassName('article').length;
      return articleCount < options.total;
    },

    updateLayout() {
        if(window.screen.width < 640) {
            this.masonry.options.gutter = 10;
        } else {
            this.masonry.options.gutter = 25;
        }
        this.masonry.layout();
    },

      buildParams() {
          return {
              page: this.page,
              offset: this.offset,
              category: this.category,
          }
      },

      async loadMore() {

          this.page = this.page + 1;

          this.loading = true;

          const { data: response } = await axios.get('/news.json', {
              params: this.buildParams()
          })
              .catch(err => {
                  this.loading = false;
                  console.error("Couldn't get posts");
              });

          this.loading = false;

          if (!response) {
              console.error(response);
              console.error("Couldn't get posts");
              return;
          }

          const { data, meta } = response;
          let newEls = [];

          if (data && data.length) {
              newEls = data.map(d => `article-${d.slug}`);
              this.entries = [...this.entries, ...data];
              this.$nextTick(() => {
                  let elems = [];
                  newEls.forEach(id => {
                      let elem = document.getElementById(id);
                      elems.push(elem);
                  });
                  this.masonry.appended(elems);
              });
          }

          this.page = meta.pagination.current_page;
          this.loading = false;

          /*
          axios.get(`/news/listings/p${this.nextPage}`)
              .then(resp => {
                let elements = this.parseHtml(resp.data);
                let elems = [];
                var fragment = document.createDocumentFragment();
                Array.from(elements).forEach(elem => {
                    fragment.appendChild( elem );
                    elems.push( elem );
                });
                this.$refs.articles.appendChild(fragment);
                this.masonry.appended(elems);
                this.nextPage += 1;
              });

           */
        },

    parseHtml(html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        return doc.body.children;
    }
  }
}